/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {ScrollViewInteractive} from 'Docs/uilib/components/fragments/scroll-view/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Keyboard support"
    }), "\n", _jsx(_components.p, {
      children: "When used for regular content, it should be possible for the user to user their keyboard to control the scrollposition."
    }), "\n", _jsxs(_components.p, {
      children: ["You can enable keyboard support with the ", _jsx(_components.code, {
        children: "interactive"
      }), " prop."]
    }), "\n", _jsx(ScrollViewInteractive, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
